import React, { useRef } from 'react';

import { Checkbox, Dialog } from '@material-ui/core';

import { RegisterConnectDialogProps } from './types';

import ConnectLogo from './assets';

import useStyles from './useStyles';
import { CustomizedButton, CustomizedTypography } from '@components/Customized';
import OutlinedTextField from '@routes/Common/OutlinedTextField';

const RegisterConnectDialogPresenter = ({
  open,
  checked,
  onCheck,
  onSubmit,
  onClose
}: RegisterConnectDialogProps) => {
  const classes = useStyles();
  const inputRef = useRef<HTMLInputElement>(null);

  /**
   * fetchConnectUser
   *
   * 커넥트가 없으면 회원가입 registerConnetUser
   *
   * 있고 유저네임이 없으면 updateConnectUser
   */

  return (
    <Dialog
      fullWidth
      classes={{ paper: classes['Register-Connect-Dialog-root'] }}
      open={open}
      onClose={onClose}
    >
      <div className="connect-logo">
        <img src={ConnectLogo} alt="" width="36px" height="40px" />
      </div>

      <div>
        <CustomizedTypography
          variant="h3"
          color="textPrimary"
          gutterBottoms={20}
        >
          캐파 커넥트에서
          <br />
          도면을 관리하세요.
        </CustomizedTypography>
        <CustomizedTypography
          variant="body2"
          color="textPrimary"
          gutterBottoms={40}
        >
          캐파 클라우드가 캐파 커넥트로 새롭게 출시했습니다.
          <br />
          아래에 이름을 적고 시작해주세요.
        </CustomizedTypography>
      </div>
      <div>
        <CustomizedTypography
          variant="body2"
          color="textPrimary"
          gutterBottoms={8}
        >
          이름
        </CustomizedTypography>
        <OutlinedTextField
          fullWidth
          placeholder="이름"
          size="large"
          align="left"
          inputRef={inputRef}
        />
      </div>

      <div className={classes['Register-Connect-Dialog-Checkbox-root']}>
        <Checkbox color="primary" checked={checked} onChange={onCheck} />
        <CustomizedTypography variant="subtitle2">
          <span className="underline">캐파 커넥트 서비스</span> 이용약관에
          동의합니다.
        </CustomizedTypography>
      </div>
      <CustomizedButton
        color="primary"
        variant="contained"
        size="large"
        onClick={() => onSubmit(inputRef.current?.value ?? '')}
        disabled={!checked}
      >
        시작
      </CustomizedButton>
    </Dialog>
  );
};

export default RegisterConnectDialogPresenter;
